import React, { useRef, useState } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import ReviewItem from "./reviewItem"
import { Href } from "../utils/helper"
import { storyblokEditable } from "gatsby-source-storyblok"

const ReviewSection = ({blok}) => {
  // console.log(blok)

  const [modalOpen, setModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState({})
  const toggleModal = ( content ) => {
    setModalOpen(!modalOpen)
    setModalContent(content)
  }

  let sliderRef = useRef(null)
  const next = () => {
    sliderRef.current.slickNext()
  }
  const previous = () => {
    sliderRef.current.slickPrev()
  }

  const PrevArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <button className={className} onClick={onClick}
        style={{ ...style, display: "block", width: "45px"}} >
        <img className="absolute top-0 left-0 w-[46px] h-[30px]" src="/icons/carousel-arrow-left.svg" alt="Prev button"/>
      </button>
    )
  }

  const NextArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <button className={className} onClick={onClick}
        style={{ ...style, display: "block", width: "45px"}} >
        <img className="absolute top-0 right-0 w-[46px] h-[30px]" src="/icons/carousel-arrow-right.svg" alt="Next button"/>
      </button>
    )
  }
  
  const settings = {
    autoplay: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    mobileFirst: true,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint:  640, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ]
  }

  

  return (
    <>
      <style>
        {`
          .latest-review-section .slick-list {
            margin: 1rem 3rem 3rem; 
          }
          @media screen and (max-width: 768px) {
            .latest-review-section .slick-list {
              margin: 1rem 1rem 3rem; 
            }
            .latest-review-section .slick-arrow {
                display: none !important;
            }
          }
        `}
      </style>
      <section className="latest-review-section max-w-screen-2xl mx-auto my-12" {...storyblokEditable(blok)}>
        <h2 className="flex justify-center font-bold text-3xl md:text-4xl my-6 md:my-10">{blok.title}</h2>
        <div className="p-0 md:px-12 lg:px-14 mx-auto">
          <div className="slider-container">
            <div className="flex justify-center gap-2 md:hidden">
              <button className="button slick-arrow-mobile block" onClick={previous}>
                <img className="w-12" src="/icons/carousel-arrow-left.svg" alt="Prev button"/>
                <div className="text-xs">Go back</div>
              </button>
              <button className="button slick-arrow-mobile block" onClick={next}>
                <img className="w-12" src="/icons/carousel-arrow-right.svg" alt="Next button"/>
                <div className="text-xs">Next</div>
              </button>
            </div>
            <Slider ref={sliderRef} {...settings} >
              {blok.reviews?.map((review, index) => 
                (<ReviewItem blok={review.content} full_slug={review.full_slug} toggleModal={toggleModal} key={index} />))
              }
            </Slider>
          </div>
        </div>

        {/* TODO: link to review list page */}
        {blok.ctaText &&
        <div className="flex justify-center">
          <a href={Href(blok.ctaUrl)} className="text-lg text-blue-700 border-2 border-blue-700 rounded-lg py-2 px-8 flex items-center">
            {blok.ctaText}
            <img className="w-8 h-3 align-middle ml-4" src="/icons/arrow-right-blue.svg" alt="Arrow right"/>
          </a>
        </div>}
      </section>

      {
      <div className="relative">
        {modalOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-50" onClick={toggleModal}></div>}
        
        <div className={`${modalOpen ? 'scale-100' : 'scale-0'} transition fixed inset-0 flex justify-center items-center z-50 max-w-screen-md mx-auto overflow-y-auto`} >
          <div className="bg-white p-8 rounded-lg">
            <div className="flex justify-end">
              <button onClick={toggleModal} className="text-xl">✖</button>
            </div>

            <div className="flex flex-col justify-between items-center">
              {modalContent.reviewImage && <img loading="lazy" src={`${modalContent.reviewImage?.filename}/m/0x720`} alt={modalContent.reviewImage?.alt} className="w-auto max-h-[360px] rounded object-cover"/>}
              <h2 className="font-serif text-2xl py-5">{modalContent.reviewSubject}</h2>
            </div>
            <div className="text-xs my-2">{modalContent.reviewerName}</div>
            <div className="flex items-center my-2">
              <img className="w-[19px] h-[21px] mr-1" src="/icons/review-tour.svg" alt="Icon"/>
              { modalContent.tour && <a href={modalContent.tour.full_slug} className="text-xs">{modalContent.tour.name}</a> }
            </div>
            <div className="review-stars my-3 flex">
              {
                Array.from({ length: modalContent.stars }, 
                  (_, index) => <img className="w-6 h-6 inline" src="/icons/review-star.svg" alt="Review star" key={index} />)
              }
            </div>
            <div className="text-sm my-4">
              {modalContent.review}
            </div>
            {/* 
            <button onClick={toggleModal} className="text-blue-800 text-sm flex items-center">
              Close<img className="w-5 h-atuo align-middle ml-1" src="/icons/arrow-right-blue.svg" alt="Arrow right"/>
            </button> 
            */}
          </div>
        </div>
      </div>
      }
    </>
  )
}
  
export default ReviewSection
